'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('@deskpro/apps-components-style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Action = require('./Action');

var _Action2 = _interopRequireDefault(_Action);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderAction(action) {
  if (typeof action === 'string') {
    return _react2.default.createElement(_Action2.default, { icon: action });
  }

  if (typeof action === 'function') {
    return action();
  }

  return action;
}

function normalize(component) {
  if (_react2.default.isValidElement(component) && component.type !== _Action2.default) {
    return _react2.default.createElement(
      'div',
      { className: "dp-ActionListItem" },
      component
    );
  }

  return component;
}

function propTypeReactElement(props, key, componentName, location, propFullName) {
  if (!_react2.default.isValidElement(props[key])) {
    return new Error('Invalid prop `' + propFullName + '` supplied to' + ' `' + componentName + '`. Validation failed.');
  }
}

/**
 * @param orientation
 * @param className
 * @param actions
 * @return {*}
 * @constructor
 */

/**
 * @param orientation
 * @param className
 * @param children a list containing a string, a function or an Action component
 * @return {*}
 * @constructor
 */
var ActionList = function ActionList(_ref) {
  var orientation = _ref.orientation,
      className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)("dp-ActionList", orientation === 'vertical' ? 'dp-ActionList--is-vertical' : '', className) },
    children && _react2.default.Children.map(children, function (action) {
      return renderAction(action);
    }).map(normalize).filter(_react2.default.isValidElement)
  );
};

ActionList.propTypes = {

  /**
   * the direction in which the items are layed out
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),

  /**
   * any additional classnames to be applied to the AppBar container
   */
  className: _propTypes2.default.string,

  /**
   * a function that will be invoked when one of the action is triggered (from a click for example)
   */
  onAction: _propTypes2.default.func
};

ActionList.defaultProps = {

  orientation: "horizontal"
};

exports.default = ActionList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Action/ActionList.js
// module id = 168
// module chunks = 0